import store from "@/store/index"

const TokenKey = 'sp_token'
const UserName = 'sp_userName'

export function getToken() {
  // return Cookies.get(TokenKey)
  return store.getters.getToken;
}

export function setToken(token) {
  // return Cookies.set(TokenKey, token)
  return store.commit("$_setToken", token);
}

export function removeToken() {
  // return Cookies.remove(TokenKey)
  return store.commit("$_removeToken");
}

export function getUserName() {
  // return Cookies.get(UserName)
  return store.getters.getUserName;
}

export function setUserName(username) {
  // return Cookies.set(UserName, username)
  return store.commit("$_setUserName", username);
}

export function removeUserName() {
  // return Cookies.remove(UserName)
  return store.commit("$_removeUserName");
}

export function loginOut() {
  removeToken();
  removeUserName();
}


// WEBPACK FOOTER //
// ./src/utils/auth.js